import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'NIFS Public Perimeters',
  type: 'feature',
  title: {
    'en-US': 'NIFS Public Perimeters',
    'pt-BR': 'Perímetros Públicos NIFS',
    'es-ES': 'Perímetros públicos del NIFS',
    'fr-FR': 'Périmètres publics du NIFS'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: {
      'en-US': 'NIFS Public Perimeters',
      'pt-BR': 'Perímetros Públicos NIFS',
      'es-ES': 'Perímetros públicos del NIFS',
      'fr-FR': 'Périmètres publics du NIFS'
    },
    items: [
      {
        text: {
          'en-US': 'NIFS Public Perimeters',
          'pt-BR': 'Perímetros Públicos NIFS',
          'es-ES': 'Perímetros públicos del NIFS',
          'fr-FR': 'Périmètres publics du NIFS'
        },
        color: '#ff000055',
        icon: 'mdi-vector-polygon'
      }
    ]
  },
  url: 'https://services3.arcgis.com/T4QMspbfLg3qTGWY/ArcGIS/rest/services/WFIGS_Interagency_Perimeters_Current/FeatureServer/0',
  icon: 'mdi-barley', // TODO: CHECK,
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: '#ff000077',
      outline: {
        width: 1,
        color: 'black'
      }
    }
  }
} as LayerRaw
